import { ListPermissionRoleOperationActivityQuerySchema } from '@standandforce/api-contract';
import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
const ActivityTypesSearchSchema = ListPermissionRoleOperationActivityQuerySchema.shape.activityTypes;
export type PermissionRoleOperationActivityType = NonNullable<z.infer<typeof ActivityTypesSearchSchema>>[number];

/**
 * URL から復元した activityType が Contract の enum に含まれるかを判定する。
 * enum は将来 additive に増え得るため（未知の値が URL に載り得る）、
 * クエリへ渡す前に既知の値だけに絞る。
 */
export function isPermissionRoleOperationActivityType(value: string): value is PermissionRoleOperationActivityType {
  return ActivityTypesSearchSchema.safeParse([value]).success;
}
export const SearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  activityTypes: ActivityTypesSearchSchema,
  /** actor の personId。クエリには URN に変換して渡す */
  actorPersonId: z.string().optional(),
  occurredFrom: z.string().optional(),
  occurredTo: z.string().optional(),
  orderDirection: z.nativeEnum(OrderDirection).default(OrderDirection.DESC)
});
export type PermissionRoleActivitySearch = z.infer<typeof SearchSchema>;